import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IConfiguration = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M12.371 1L12.9355 3.98387L15.5968 5.03226L17.9355 3.74194L20.3548 6.80645L18.2581 8.98387L18.5 11.8871L21 13.4194L19.1452 16.9677L16.3226 15.9194L14.2258 17.7742V20.6774L10.1129 21L9.54839 18.0968L6.80645 16.9677L4.46774 18.3387L2.04839 14.9516L4.06452 13.0161V10.2742L1.48387 8.66129L3.09678 5.03226L5.91936 5.91935L8.25807 4.3871V1.40323L12.371 1Z"
              stroke={props.color ?? '#37474F'}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle
              r="3.28226"
              transform="matrix(-1 0 0 1 11.1613 11.001)"
              stroke={props.color ?? '#37474F'}
              strokeWidth="1.5"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IConfiguration;
